module.exports = __webpack_public_path__ + "static/barda-96c7d76d58b8fea4e64d0563ad40ee01.jpg";